import PropTypes from 'prop-types';

const CreateFormPropType = {
  classes: PropTypes.instanceOf(Object),
  type: PropTypes.string,
};

export default CreateFormPropType;
